import React from "react";
import { Box, styled, Divider, Typography } from "@mui/material";
import SidebarList from "../lists/SidebarList";

interface SidebarNavigationInterface {
  options: {
    top?: {
      type: string;
      items: {
        id: number;
        component: React.ReactElement | undefined;
      }[];
    };
    middle?: {
      type: string;
      items: {
        id: number;
        component: React.ReactElement | undefined;
      }[];
    };
    bottom?: {
      type: string;
      items: {
        id: number;
        component: React.ReactElement | undefined;
      }[];
    };
  };
}

const Menu = styled(Box)<{ hasOnlyIcons?: boolean; hasBorder?: boolean }>(
  ({ hasBorder = true, theme }) => ({
    width: "100%",
    background: theme.palette.common["white"],
    borderRight: hasBorder ? `1px solid grey` : undefined,
    height: "100%",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  })
);

const SidebarNavigation = ({ options }: SidebarNavigationInterface) => {
  return (
    <React.Fragment>
      <Menu hasBorder>
        <Typography variant="h3" fontWeight="700">
          Filters
        </Typography>
        {options.top && (
          <SidebarList
            filterType={options.top.type}
            options={options.top.items}
          />
        )}
        {options.middle && options.middle.items.length > 0 && (
          <React.Fragment>
            <Divider style={{ margin: 14 }} />
            <SidebarList
              filterType={options.middle.type}
              options={options.middle.items}
            />
          </React.Fragment>
        )}
        {options.bottom && options.bottom.items.length > 0 && (
          <React.Fragment>
            <Divider style={{ margin: 14 }} />
            <SidebarList
              filterType={options.bottom.type}
              options={options.bottom.items}
            />
          </React.Fragment>
        )}
      </Menu>
    </React.Fragment>
  );
};

export default SidebarNavigation;
